import React from 'react'
import styled from 'styled-components'
import useDoublePointsCampaignTier from '../hooks/useDoublePointsCampaignTier'

const Background = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;

  &.bronze {
    background: ${props => props.theme.palette.product.loyalty.bronze.gradientPrimaryBackground};
    color: ${props => props.theme.palette.product.loyalty.bronze.darkContrast};
  }

  &.silver {
    background: ${props => props.theme.palette.product.loyalty.silver.gradientPrimaryBackground};
    color: ${props => props.theme.palette.product.loyalty.silver.darkContrast};
  }

  &.gold {
    background: ${props => props.theme.palette.product.loyalty.gold.gradientPrimaryBackground};
    color: ${props => props.theme.palette.product.loyalty.gold.darkContrast};
  }

  &.platinum {
    background: ${props => props.theme.palette.product.loyalty.platinum.gradientPrimaryBackground};
    color: ${props => props.theme.palette.product.loyalty.platinum.lightContrast};
  }
`

const Container = styled.div`
  width: 100%;
  height: 100%;
`

interface Props {
  className?: string
}

function DoublePointTakeoverBackground(props: Props) {
  const { className } = props
  const displayTier = useDoublePointsCampaignTier()

  return <Container className={className}>
    <Background className={displayTier}>
    </Background>
  </Container>
}

export default DoublePointTakeoverBackground
